import { type EpgDateEx } from '$/epg/dates'
import { produce } from 'immer'
import { DATE_FORMATS, formatStartTime } from '~/shared/helpers/date'

export const translateDate = (date: EpgDateEx) =>
  produce(date, (draft) => {
    const yesterday = 'Yesterday'
    const today = 'Today'
    const title = formatStartTime(
      new Date(draft.year, draft.month, draft.day),
      DATE_FORMATS.DD_MMM
    )
    if (draft.isYesterday) {
      draft.title = `${yesterday}, ${title}`
    } else if (draft.isToday) {
      draft.title = `${today}, ${title}`
    } else {
      draft.title = title
    }
  })
